module.exports = __webpack_public_path__ + "img/pre_eg_1.8964e5a6.png";